mutation QuickbooksCreateInvoiceForLead($input: QuickbooksCreateInvoiceForLeadInput!) {
    quickbooksCreateInvoiceForLead(input: $input) {
        lead {
            id
            externalResources {
                externalService
                externalResourceType
                externalId
            }
        }
    }
}
